import React, { Component } from "react";
import { withRouter } from "../../hoc/withRouter";
import { config } from "../../config/GeneralConfig";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectTypeNotice extends Component {
  initState = {
    dataOption: config.option_notice_type,
  };
  state = { ...this.initState };

  componentDidMount = async () => {
    try {
    } catch (error) {
      this.setState({
        dataOption: [],
      });
    }
  };

  render() {
    return (
      <Form.Item label="Tipe Notice" className="col-lg-12 my-1 py-1">
        <Select style={{ fontSize: "85%", minWidth: "200px" }} placeholder="Select Tipe Notice" value={this.props.value} onChange={this.props.onChangeValue} mode={this.props.mode}>
          {this.state.dataOption.map((d, i) => {
            return (
              <Option key={d} value={d}>
                {d?.toString()?.toUpperCase()}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default withRouter(SelectTypeNotice);
